import React from 'react'
import SimpleBlockContent from '../../../SimpleBlockContent'
import styles from './styles.module.css'

function RichText(props) {
  const { text } = props

  return (
    <div className={styles.wrapper}>
      <SimpleBlockContent blocks={text}/>
    </div>
  )
}

export default RichText
